/**
 * ライブアクティビティフィードの ON/OFF とその永続化（タスク54）。
 *
 * - 既定は ON（人がいる感じを出すのが目的のため。OFF が初期値だと機能に気づかれない）。
 * - 選択は localStorage に保存する（i18n/lang.ts の useLang と同じ形）。
 */
import { useCallback, useState } from 'react';

const STORAGE_KEY = 'reinvent_feed';

/** localStorage から読む（未設定・不正値は既定 ON）。 */
function loadFeedEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'off';
  } catch {
    return true;
  }
}

export interface UseFeedEnabledResult {
  feedEnabled: boolean;
  /** ON ↔ OFF を反転する。 */
  toggleFeed: () => void;
}

/** フィードの ON/OFF フック。App で1回呼び、右上ツールバーとフィードに配布する。 */
export function useFeedEnabled(): UseFeedEnabledResult {
  const [feedEnabled, setFeedEnabled] = useState<boolean>(() =>
    loadFeedEnabled(),
  );

  const toggleFeed = useCallback(() => {
    setFeedEnabled((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, next ? 'on' : 'off');
      } catch {
        // 永続化失敗（プライベートモード等）は無視。セッション内の切替は効く。
      }
      return next;
    });
  }, []);

  return { feedEnabled, toggleFeed };
}
